export const formatDate = (d) =>
  new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

export const formatTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const timeRange = (e) => (e.end_time ? `${formatTime(e.start_time)} – ${formatTime(e.end_time)}` : formatTime(e.start_time));

export const KIND = {
  practice: { label: "Practice", color: "#2563eb" },
  game: { label: "Game", color: "#dc2626" },
  other: { label: "Event", color: "#0d9488" },
};
